import Offcanvas from "react-bootstrap/Offcanvas";
import {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "moment-timezone";

import {SwalAlertClass} from "core/swalClass";
import FormButton from "components/buttons/FormButton";
import useCustomTranslation from "core/customTranslation";
import {translations} from "../translations";
import {addOrUpdateList} from "core/utils/arrays";
import axiApi from "ApiCaller";

const FormMode = ({setShowCanvas, showCanvas, item, setItems, items, setItemsShow}) => {
    const {t: _Tc} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    const [formData, setFormData] = useState({...item});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setFormData({...item});
    }, [item]);

    const handleClose = () => setShowCanvas(false);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setFormData((prevFormData) => ({...prevFormData, [name]: value}));
    };

    const clickCancel = () => {
        setShowCanvas(false);
    };

    const onSubmit = (e) => {
        setIsLoading(true);

        if (error()) {
            setIsLoading(false);
            return;
        }

        e.preventDefault();
        handleClose();
        axiApi
            .post(`/api/devices/add_edit_groups/`, formData)
            .then((resp) => {
                if (resp.data.status) {
                    if (formData.id) {
                        items.current.showed = addOrUpdateList(items.current.showed, resp.data.item);
                    } else {
                        items.current.showed.push(resp.data.item);
                    }
                    setItems(resp.data.item);
                    setItemsShow([...items.current.showed]);
                    setShowCanvas(false);
                    Alert.success(_Tc("preview.saved"), _Tc("preview.saved.success"));
                } else {
                    Alert.warning(_Tc("preview.error"), _Tc("preview.error.admin"));
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                setIsLoading(false);
            });
    };

    const error = () => {
        for (let [field, value] of Object.entries(formData)) {
            if (field === "name" && value === "") {
                return true;
            }
        }
        return false;
    };

    return (
        <>
            <Offcanvas show={showCanvas} onHide={handleClose} placement="end" backdrop="false" style={{width: "30%"}}>
                <Offcanvas.Header className="preview-canvas" closeButton>
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="fa-solid fa-wrench" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{_Tc("preview.add.group")}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        <div className="col-md-3 text-md-end mt-2">
                            <label>{_Tc("field.name")}</label>
                        </div>

                        <div className="col-md-7">
                            <input type="text" className="form-control mb-2" id="name" name="name" onChange={handleChange} />
                        </div>
                    </div>
                </Offcanvas.Body>

                <div className="text-center col-12 mb-4">
                    <button type="button" className="btn btn-secondary me-4" onClick={clickCancel}>
                        {_Tc("button.cancel")}
                    </button>
                    <FormButton type="button" className="btn btn-primary" onClick={onSubmit} isProcessing={isLoading}>
                        {_Tc("button.add")}
                    </FormButton>
                </div>
            </Offcanvas>
        </>
    );
};

export default FormMode;
